<template>
  <el-dialog title="查询工单信息" :append-to-body="true" :modal-append-to-body="true" :close-on-click-modal="falseValue"
             :visible.sync="showDialog" :modal="falseValue" custom-class="dialog-style list-dialog" width="1200px"
             @close="dialogClose" v-el-drag-dialog v-el-dialog-center>
    <template>
      <div id="containt">
        <div class="grid-height" >

          <div class="table_main">
            <vxe-grid ref="table-m1" :radio-config="{ highlight: true }"
                      @cell-click="cellClickEvent"
                      @radio-change="radioChangeEvent"
                      show-overflow height="550" :row-config="{ isHover: true }"
                      v-bind="vxeOption" @resizable-change="$vxeTableUtil.onColumnWitchChange"
                      @custom="$vxeTableUtil.customHandle">

              <template #form>
                <div class="clearfix screen-btns">
                  <div class="fr">
                    <vxe-button icon="el-icon-brush" class="button-sty" @click="resetEvent" type="text"
                                status="primary" plain>重置</vxe-button>
                    <vxe-button status="warning" icon="el-icon-search" class="button-sty"
                                @click="searchEvent">搜索</vxe-button>
                  </div>
                </div>
                <vxe-form ref="form" class="screen-box" title-width="92px" title-align="right"
                          :data="formData" @submit="searchEvent" @reset="searchEvent">
                  <vxe-form-item title="工单号:" field="brandName">
                    <template v-slot>
                      <el-input v-model="searchOrderNo" size="small" clearable />
                    </template>
                  </vxe-form-item>
                </vxe-form>
              </template>
              <template #pager>
                <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage"></pager>
              </template>
            </vxe-grid>
          </div>
        </div>
      </div>
    </template>
    <span slot="footer" class="dialog-footer">
			<span class="fl tips" v-if="!selectMulti">注：双击确认选择（单选）</span>
			<el-button type="primary" plain class="button-sty" @click="dialogClose">
				<i class="el-icon-close el-icon"></i>
				取 消
			</el-button>
			<el-button type="primary" @click="commitRow" class="button-sty">
				<i class="el-icon-check el-icon"></i>
				确 定
			</el-button>
		</span>
  </el-dialog>
</template>

<script>
import { selectDialogMixins } from '@/mixins/selectDialog/index.js';
import { initVxeTable } from '@/const/crud/admin/table'

import { fetchTree } from "@/api/admin/type_tree";
import pager from '@/components/pager/index.vue'
import api from '@/api/projectApi'
export default {
  name: 'saleConfigDialog',
  props: ['visiable', 'multi', 'param', 'checkSubjectId'],
  mixins: [selectDialogMixins],
  components: { pager },

  created() {
    if (this.checkSubjectId !== '') {
      this.formData.checkSubjectId = this.checkSubjectId
    }
    this.initSetting();
  },

  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
    total(newVal, oldVal) {
      this.$refs.pager.tableDataTotal = newVal
    }
  },

  data() {
    return {
      total: 0,
      filterText: '',
      data: [],

      pageSizes: [10, 20, 100],
      //以上树形
      activeName: 'second',
      dataId: 0,
      showEdit: false,
      vxeOption: {},
      isRouterAlive: true,
      // 查询参数
      formData: {
        size: 0,
        current: 1,
        searchCount: false,
        orderNo: "",
        checkSubjectId: ''
      },
      showDialog: true,
      falseValue: false,
      selectMulti: true,
      searchOrderNo: '',
      selectedRow: {
        id: '', orderNo: ''
      }
    };
  },


  methods: {
    flushed() {
      this.$refs['table-m1'].commitProxy('reload');
    },

    cellClickEvent (e) {
      console.log(e.row.id,'单元格点击事件')
    },


    radioChangeEvent ({ row }) {
      this.selectedRow = {id: row.id, orderNo: row.orderNo}
    },


    commitRow() {
      if (this.selectedRow.orderNo !== '') {
        this.$emit('commitSelectedRow', this.selectedRow)
        this.dialogClose()
      } else {
        this.$message.warning('请先选中订单')
      }
    },


    // 分页功能
    changeTablePage(page, flag) {
      this.formData.size = page.pageSize
      this.formData.current = page.currentPage
      this.formData.searchCount = flag
      this.initTableList();
    },


    // 搜索
    searchEvent() {
      this.formData.orderNo = this.searchOrderNo
      this.$refs.pager.clearStoreTableDataTotal()
      this.formData.current = 1
      this.formData.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
    },

    // 重置
    resetEvent() {
      this.searchOrderNo = ''
      this.formData.orderNo = ''
      this.formData.current = 1
      this.formData.searchCount = false
      this.$refs.pager.reset()  // 重置分页器
      this.flushed()
      this.reloadTree()
    },


    // 新增
    openEditDialog(id) {
      this.dataId = !id || typeof id == 'object' ? 0 : id;
      this.activeName = 'first';
      this.$openEditView('showEdit');
    },



    initTableList() {
      let tableOption = {
        vue: this,
        tableRef: 'table-m1',
        tableName: 'basic_fault_code_list-m1',
        path: api.soOrder.getPopListPage,
        param: this.formData,
        method: 'post',
        columns: [
          { type: "radio", width: 40, title: '', resizable: false, fixed: 'left' },
          { title: '订单号', field: 'orderNo', width: 110, },
          { title: '订单状态', field: 'stat', width: 110, slots: {
              default: ({ row }) => {
                if (row.stat == 1) {
                  return [
                    <div>
                      <span>登记</span>
                    </div>
                  ];
                } else if (row.stat == 2) {
                  return [
                    <div>
                      <span>发布</span>
                    </div>
                  ];
                } else if (row.stat == 5) {
                  return [
                    <div>
                      <span>已派网点</span>
                    </div>
                  ];
                } else if (row.stat == 9) {
                  return [
                    <div>
                      <span>已派师傅</span>
                    </div>
                  ];
                } else if (row.stat == 13) {
                  return [
                    <div>
                      <span>已出发</span>
                    </div>
                  ];
                } else if (row.stat == 17) {
                  return [
                    <div>
                      <span>已上门</span>
                    </div>
                  ];
                } else if (row.stat == 20) {
                  return [
                    <div>
                      <span>完工暂存</span>
                    </div>
                  ];
                } else if (row.stat == 21) {
                  return [
                    <div>
                      <span>已完工</span>
                    </div>
                  ];
                } else if (row.stat == 22) {
                  return [
                    <div>
                      <span>网点确认完工</span>
                    </div>
                  ];
                } else if (row.stat == 23) {
                  return [
                    <div>
                      <span>中心确认完工</span>
                    </div>
                  ];
                } else if (row.stat == 24) {
                  return [
                    <div>
                      <span>总部确认完工</span>
                    </div>
                  ];
                } else if (row.stat == 91) {
                  return [
                    <div>
                      <span>待结算</span>
                    </div>
                  ];
                } else if (row.stat == 92) {
                  return [
                    <div>
                      <span>结算驳回</span>
                    </div>
                  ];
                } else if (row.stat == 93) {
                  return [
                    <div>
                      <span>结算中止</span>
                    </div>
                  ];
                } else if (row.stat == 94) {
                  return [
                    <div>
                      <span>已结算</span>
                    </div>
                  ];
                } else if (row.stat == 98) {
                  return [
                    <div>
                      <span>挂起</span>
                    </div>
                  ];
                } else if (row.stat == 99) {
                  return [
                    <div>
                      <span>取消</span>
                    </div>
                  ];
                }
              }
            }
          },
          { title: '服务类型', field: 'serverTypeName', width: 110, },
          { title: '用户姓名', field: 'userName', width: 110, },
          { title: '用户手机', field: 'userMobile', width: 110, },
          { title: '用户地址', field: 'area', width: 250,
            slots: {
              default: ({ row }) => {
                return [
                  <div><span>{row.userProvice}{row.userCity}{row.userCounty}{row.userTown}{row.userAddress}</span></div>
                ]
              }
            }
          },
        ]
      };
      this.vxeOption = initVxeTable(tableOption);
      this.flushed()
    },


  }
};
</script>
<style lang="scss" scoped>
// 单选框的样式
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon:before {
  top: -1px;
}

::v-deep.vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--checked-icon:after {
  top: 0.3em;
}

#containt .grid-height {
  height: 570px;
}

::v-deep .el-dialog {
  // height: 700px;
  overflow: hidden;
}

::v-deep body .dialog-style {
  border-radius: 8px;
  -webkit-box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  box-shadow: 0 0 24px rgba(0, 0, 0, 0.22);
  // height: 700px;
  overflow: hidden;
}

/* 注意此处不能有scoped 否则样式无法生效 */
.el-cascader-panel {
  .el-radio__inner {
    border: 0px;
    background: transparent;
  }

  .el-radio__input.is-checked .el-radio__inner {
    background: none;
  }

  .el-radio {
    height: 100%;
    width: 150px;
    position: absolute;
    z-index: 10;
  }
}

.table_main {
  padding-top: 5px;
  padding-left: 5px;
  border: 1px solid #ededed;
  // width: calc(100% - 215px);
  border-bottom: none;

  .el-pagination {
    padding: 2px;

  }
}

.left_tree {
  width: 205px;

  .title {
    text-align: left;
    width: 182px;
    padding: 7px 0 5px !important;
    font-size: 13px;
    color: rgba(58, 39, 39, 0.96);

    >span {
      position: relative;
      left: 4px;
      top: -3px;
    }
  }

  ::v-deep.el-tree-node__label {
    width: calc(100% - 32px);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    color: rgba(86, 86, 86, 0.96);
  }
}

.tree_icon {
  background: #f0f3ff;
}

// 重新修改tree组件样式
::v-deep.tree-line {
  .el-tree-node {
    position: relative;
    padding-left: 0px;
  }

  .el-tree-node__content {
    margin-top: 0px;
  }

  .el-tree-node__children {
    padding-left: 16px;
  }

  .el-tree-node::before {
    content: '';
    height: 100%;
    width: 1px;
    position: absolute;
    left: -3px;
    top: -26px;
    border-width: 1px;
    border-left: 1px dashed #d9d9d9;
  }

  .el-tree-node:last-child::before {
    height: 38px;
  }

  .el-tree-node::after {
    content: '';
    width: 24px;
    height: 1px;
    position: absolute;
    left: -3px;
    top: 12px;
    border-width: 1px;
    border-top: 1px dashed #d9d9d9;
  }

  &>.el-tree-node::after {
    border-top: none;
  }

  &>.el-tree-node::before {
    border-left: none;
  }

  .el-tree-node__expand-icon {
    font-size: 17px;

    // color: #000;
    &.is-leaf {
      color: transparent;
      // display: none;
    }
  }
}
::v-deep .vxe-grid .vxe-table--render-default .vxe-cell--radio .vxe-radio--icon {
  font-size: 14px !important;
}
</style>
